/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Tool} from '../models/Tool';

export interface GetAccessManagementTools$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccessManagementToolsRequest = createAction<PayloadData<void>>('TOOL__GET_ACCESS_MANAGEMENT_TOOLS__REQUEST');
export const getAccessManagementToolsSuccess = createAction<PayloadData<Array<Tool>>>('TOOL__GET_ACCESS_MANAGEMENT_TOOLS__SUCCESS');
export const getAccessManagementToolsFailure = createAction<PayloadData<Error, void, true>>('TOOL__GET_ACCESS_MANAGEMENT_TOOLS__FAILURE');

export const getAccessManagementToolsActions = [
    getAccessManagementToolsRequest,
    getAccessManagementToolsSuccess,
    getAccessManagementToolsFailure
] as const;

/**
 * Get all available tools with their roles
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccessManagementTools = (config?: GetAccessManagementTools$Config) => {
    return {
        CALL_API: {
            types: getAccessManagementToolsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/tools`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

